import React,{useContext} from 'react';
//import Product cotext
import { ProductContext } from '../contexts/ProductContext'
//import components
import Product from '../components/Product';

//import Hero
import Hero from '../components/Hero'

const Home = () => {
  const { Products } = useContext(ProductContext);
  //get only men's & women's clohting category
  const filterProducts = Products.filter(item => {
    return (
      item.category === "men's clothing" || item.category ===
      "women's clothing"
    )
  });
  return <div>
    <Hero />

    <section className='py-16'>
      <div className='container mx-auto'>
        <div className='grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 xl:grid-cols-5 gap-8 max-w-sm mx-auto md:max-w-none md:mx-0'>
          {filterProducts.map(product => {
            return (
           <Product key={product.id} product={product}/>
            
            )
          })}
        </div>
      </div>
    </section>
  </div>;
};

export default Home;
